export const PRODUCT_BEACONS_MAP_KEY = "productBeaconsMap";
